import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

import { handle } from '../../../common/event-emitter/handle';
import { registerHandler } from '../../../common/event-emitter/register-handler';
import { HarvestScheduler } from '../../../common/harvest/harvest-scheduler';
import { single } from '../../../common/util/invoke';
import { timeToFirstByte } from '../../../common/vitals/time-to-first-byte';
import { FEATURE_NAMES, FEATURE_TO_ENDPOINT } from '../../../loaders/features/features';
import { SUPPORTABILITY_METRIC_CHANNEL } from '../../metrics/constants';
import { AggregateBase } from '../../utils/aggregate-base';
import { API_TRIGGER_NAME, FEATURE_NAME, INTERACTION_STATUS } from '../constants';
import { AjaxNode } from './ajax-node';
import { InitialPageLoadInteraction } from './initial-page-load-interaction';
import { Interaction } from './interaction';

var _handleAjaxEvent = /*#__PURE__*/new WeakSet();

var _handleJserror = /*#__PURE__*/new WeakSet();

var _registerApiHandlers = /*#__PURE__*/new WeakSet();

export var Aggregate = /*#__PURE__*/function (_AggregateBase) {
  _inherits(Aggregate, _AggregateBase);

  var _super = _createSuper(Aggregate);

  function Aggregate(agentRef, _ref) {
    var _this;

    var domObserver = _ref.domObserver;

    _classCallCheck(this, Aggregate);

    _this = _super.call(this, agentRef, FEATURE_NAME);

    _registerApiHandlers.add(_assertThisInitialized(_this));

    _handleJserror.add(_assertThisInitialized(_this));

    _handleAjaxEvent.add(_assertThisInitialized(_this));

    var harvestTimeSeconds = agentRef.init.soft_navigations.harvestTimeSeconds || 10;
    _this.interactionsToHarvest = _this.events;
    _this.domObserver = domObserver;
    _this.initialPageLoadInteraction = new InitialPageLoadInteraction(agentRef.agentIdentifier);
    timeToFirstByte.subscribe(function (_ref2) {
      var attrs = _ref2.attrs;
      var loadEventTime = attrs.navigationEntry.loadEventEnd;
      _this.initialPageLoadInteraction.forceSave = true;

      _this.initialPageLoadInteraction.done(loadEventTime);

      _this.interactionsToHarvest.add(_this.initialPageLoadInteraction);

      _this.initialPageLoadInteraction = null; // Report metric on the initial page load time

      handle(SUPPORTABILITY_METRIC_CHANNEL, ['SoftNav/Interaction/InitialPageLoad/Duration/Ms', Math.round(loadEventTime)], undefined, FEATURE_NAMES.metrics, _this.ee);
    });
    _this.latestRouteSetByApi = null;
    _this.interactionInProgress = null; // aside from the "page load" interaction, there can only ever be 1 ongoing at a time

    _this.blocked = false;

    _this.waitForFlags(['spa']).then(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 1),
          spaOn = _ref4[0];

      if (spaOn) {
        _this.drain();

        var scheduler = new HarvestScheduler(FEATURE_TO_ENDPOINT[_this.featureName], {
          onFinished: function onFinished(result) {
            return _this.postHarvestCleanup(result.sent && result.retry);
          },
          getPayload: function getPayload(options) {
            return _this.makeHarvestPayload(options.retry);
          },
          retryDelay: harvestTimeSeconds,
          onUnload: function onUnload() {
            var _this$interactionInPr;

            return (_this$interactionInPr = _this.interactionInProgress) === null || _this$interactionInPr === void 0 ? void 0 : _this$interactionInPr.done();
          } // return any held ajax or jserr events so they can be sent with EoL harvest

        }, _assertThisInitialized(_this));
        scheduler.startTimer(harvestTimeSeconds, 0);
      } else {
        _this.blocked = true; // if rum response determines that customer lacks entitlements for spa endpoint, this feature shouldn't harvest

        _this.deregisterDrain();
      }
    }); // By default, a complete UI driven interaction requires event -> URL change -> DOM mod in that exact order.


    registerHandler('newUIEvent', function (event) {
      return _this.startUIInteraction(event.type, Math.floor(event.timeStamp), event.target);
    }, _this.featureName, _this.ee);
    registerHandler('newURL', function (timestamp, url) {
      var _this$interactionInPr2;

      return (_this$interactionInPr2 = _this.interactionInProgress) === null || _this$interactionInPr2 === void 0 ? void 0 : _this$interactionInPr2.updateHistory(timestamp, url);
    }, _this.featureName, _this.ee);
    registerHandler('newDom', function (timestamp) {
      var _this$interactionInPr3, _this$interactionInPr4;

      (_this$interactionInPr3 = _this.interactionInProgress) === null || _this$interactionInPr3 === void 0 ? void 0 : _this$interactionInPr3.updateDom(timestamp);
      if ((_this$interactionInPr4 = _this.interactionInProgress) !== null && _this$interactionInPr4 !== void 0 && _this$interactionInPr4.seenHistoryAndDomChange()) _this.interactionInProgress.done();
    }, _this.featureName, _this.ee);

    _classPrivateMethodGet(_assertThisInitialized(_this), _registerApiHandlers, _registerApiHandlers2).call(_assertThisInitialized(_this));

    registerHandler('ajax', _classPrivateMethodGet(_assertThisInitialized(_this), _handleAjaxEvent, _handleAjaxEvent2).bind(_assertThisInitialized(_this)), _this.featureName, _this.ee);
    registerHandler('jserror', _classPrivateMethodGet(_assertThisInitialized(_this), _handleJserror, _handleJserror2).bind(_assertThisInitialized(_this)), _this.featureName, _this.ee);
    return _this;
  }

  _createClass(Aggregate, [{
    key: "serializer",
    value: function serializer(eventBuffer) {
      // The payload depacker takes the first ixn of a payload (if there are multiple ixns) and positively offset the subsequent ixns timestamps by that amount.
      // In order to accurately portray the real start & end times of the 2nd & onward ixns, we hence need to negatively offset their start timestamps with that of the 1st ixn.
      var firstIxnStartTime = 0; // the very 1st ixn does not require any offsetting

      var serializedIxnList = [];

      var _iterator = _createForOfIteratorHelper(eventBuffer),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var interaction = _step.value;
          serializedIxnList.push(interaction.serialize(firstIxnStartTime));
          if (!firstIxnStartTime) firstIxnStartTime = Math.floor(interaction.start);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return "bel.7;".concat(serializedIxnList.join(';'));
    }
  }, {
    key: "startUIInteraction",
    value: function startUIInteraction(eventName, startedAt, sourceElem) {
      var _this$interactionInPr5,
          _this$interactionInPr6,
          _this2 = this;

      // this is throttled by instrumentation so that it isn't excessively called
      if ((_this$interactionInPr5 = this.interactionInProgress) !== null && _this$interactionInPr5 !== void 0 && _this$interactionInPr5.createdByApi) return; // api-started interactions cannot be disrupted aka cancelled by UI events (and the vice versa applies as well)

      if (((_this$interactionInPr6 = this.interactionInProgress) === null || _this$interactionInPr6 === void 0 ? void 0 : _this$interactionInPr6.done()) === false) return;
      this.interactionInProgress = new Interaction(this.agentIdentifier, eventName, startedAt, this.latestRouteSetByApi);

      if (eventName === 'click') {
        var sourceElemText = getActionText(sourceElem);
        if (sourceElemText) this.interactionInProgress.customAttributes.actionText = sourceElemText;
      }

      this.interactionInProgress.cancellationTimer = setTimeout(function () {
        _this2.interactionInProgress.done(); // Report metric on frequency of cancellation due to timeout for UI ixn


        handle(SUPPORTABILITY_METRIC_CHANNEL, ['SoftNav/Interaction/TimeOut'], undefined, FEATURE_NAMES.metrics, _this2.ee);
      }, 30000); // UI ixn are disregarded after 30 seconds if it's not completed by then

      this.setClosureHandlers();
    }
  }, {
    key: "setClosureHandlers",
    value: function setClosureHandlers() {
      var _this3 = this;

      this.interactionInProgress.on('finished', function () {
        var ref = _this3.interactionInProgress;

        _this3.interactionsToHarvest.add(_this3.interactionInProgress);

        _this3.interactionInProgress = null;

        _this3.domObserver.disconnect(); // can stop observing whenever our interaction logic completes a cycle
        // Report metric on the ixn duration


        handle(SUPPORTABILITY_METRIC_CHANNEL, ["SoftNav/Interaction/".concat(ref.newURL !== ref.oldURL ? 'RouteChange' : 'Custom', "/Duration/Ms"), Math.round(ref.end - ref.start)], undefined, FEATURE_NAMES.metrics, _this3.ee);
      });
      this.interactionInProgress.on('cancelled', function () {
        _this3.interactionInProgress = null;

        _this3.domObserver.disconnect();
      });
    }
    /**
     * Find the active interaction (current or past) for a given timestamp. Note that historic lookups mostly only go as far back as the last harvest for this feature.
     * Also, the caller should check the status of the interaction returned if found via {@link Interaction.status}, if that's pertinent.
     * TIP: Cancelled (status) interactions are NOT returned!
     * IMPORTANT: Finished interactions are in queue for next harvest! It's highly recommended that consumer logic be synchronous for safe reference.
     * @param {DOMHighResTimeStamp} timestamp
     * @returns An {@link Interaction} or undefined, if no active interaction was found.
     */

  }, {
    key: "getInteractionFor",
    value: function getInteractionFor(timestamp) {
      var _this$interactionInPr7, _this$initialPageLoad;

      /* In the sole case wherein there can be two "interactions" overlapping (initialPageLoad + regular route-change),
        the regular interaction should get precedence in being assigned the "active" interaction in regards to our one-at-a-time model.
      */
      if ((_this$interactionInPr7 = this.interactionInProgress) !== null && _this$interactionInPr7 !== void 0 && _this$interactionInPr7.isActiveDuring(timestamp)) return this.interactionInProgress;
      var saveIxn;
      var interactionsBuffer = this.interactionsToHarvest.get();

      for (var idx = interactionsBuffer.length - 1; idx >= 0; idx--) {
        // reverse search for the latest completed interaction for efficiency
        var finishedInteraction = interactionsBuffer[idx];

        if (finishedInteraction.isActiveDuring(timestamp)) {
          if (finishedInteraction.trigger !== 'initialPageLoad') return finishedInteraction; // It's possible that a complete interaction occurs before page is fully loaded, so we need to consider if a route-change ixn may have overlapped this iPL
          else saveIxn = finishedInteraction;
        }
      }

      if (saveIxn) return saveIxn; // if an iPL was determined to be active and no route-change was found active for the same time, then iPL is deemed the one

      if ((_this$initialPageLoad = this.initialPageLoadInteraction) !== null && _this$initialPageLoad !== void 0 && _this$initialPageLoad.isActiveDuring(timestamp)) return this.initialPageLoadInteraction; // lowest precedence and also only if it's still in-progress
      // Time must be when no interaction is happening, so return undefined.
    }
    /**
     * Handles or redirect ajax event based on the interaction, if any, that it's tied to.
     * @param {Object} event see Ajax feature's storeXhr function for object definition
     */

    /**
     * Decorate the passed-in params obj with properties relating to any associated interaction at the time of the timestamp.
     * @param {Object} params reference to the local var instance in Jserrors feature's storeError
     * @param {DOMHighResTimeStamp} timestamp time the jserror occurred
     */

  }]);

  return Aggregate;
}(AggregateBase);

function _handleAjaxEvent2(event) {
  var _this4 = this;

  var associatedInteraction = this.getInteractionFor(event.startTime);

  if (!associatedInteraction) {
    // no interaction was happening when this ajax started, so give it back to Ajax feature for processing
    handle('returnAjax', [event], undefined, FEATURE_NAMES.ajax, this.ee);
  } else {
    if (associatedInteraction.status === INTERACTION_STATUS.FIN) processAjax(this.agentIdentifier, event, associatedInteraction); // tack ajax onto the ixn object awaiting harvest
    else {
        // same thing as above, just at a later time -- if the interaction in progress is cancelled, just send the event back to ajax feat unmodified
        associatedInteraction.on('finished', function () {
          return processAjax(_this4.agentIdentifier, event, associatedInteraction);
        });
        associatedInteraction.on('cancelled', function () {
          return handle('returnAjax', [event], undefined, FEATURE_NAMES.ajax, _this4.ee);
        });
      }
  }

  function processAjax(agentId, event, parentInteraction) {
    var newNode = new AjaxNode(agentId, event);
    parentInteraction.addChild(newNode);
  }
}

function _handleJserror2(params, timestamp) {
  var _this5 = this;

  var associatedInteraction = this.getInteractionFor(timestamp);
  if (!associatedInteraction) return; // do not need to decorate this jserror params
  // Whether the interaction is in-progress or already finished, the id will let jserror buffer it under its index, until it gets the next step instruction.

  params.browserInteractionId = associatedInteraction.id;

  if (associatedInteraction.status === INTERACTION_STATUS.FIN) {
    // This information cannot be relayed back via handle() that flushes buffered errs because this is being called by a jserror's handle() per se and before the err is buffered.
    params._softNavFinished = true; // instead, signal that this err can be processed right away without needing to be buffered aka wait for an in-progress ixn

    params._softNavAttributes = associatedInteraction.customAttributes;
  } else {
    // These callbacks may be added multiple times for an ixn, but just a single run will deal with all jserrors associated with the interaction.
    // As such, be cautious not to use the params object since that's tied to one specific jserror and won't affect the rest of them.
    associatedInteraction.on('finished', single(function () {
      return handle('softNavFlush', [associatedInteraction.id, true, associatedInteraction.customAttributes], undefined, FEATURE_NAMES.jserrors, _this5.ee);
    }));
    associatedInteraction.on('cancelled', single(function () {
      return handle('softNavFlush', [associatedInteraction.id, false, undefined], undefined, FEATURE_NAMES.jserrors, _this5.ee);
    })); // don't take custom attrs from cancelled ixns
  }
}

function _registerApiHandlers2() {
  var INTERACTION_API = 'api-ixn-';
  var thisClass = this;
  registerHandler(INTERACTION_API + 'get', function (time) {
    var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        waitForEnd = _ref5.waitForEnd;

    // In here, 'this' refers to the EventContext specific to per InteractionHandle instance spawned by each .interaction() api call.
    // Each api call aka IH instance would therefore retain a reference to either the in-progress interaction *at the time of the call* OR a new api-started interaction.
    this.associatedInteraction = thisClass.getInteractionFor(time);

    if (!this.associatedInteraction) {
      // This new api-driven interaction will be the target of any subsequent .interaction() call, until it is closed by EITHER .end() OR the regular seenHistoryAndDomChange process.
      this.associatedInteraction = thisClass.interactionInProgress = new Interaction(thisClass.agentIdentifier, API_TRIGGER_NAME, time, thisClass.latestRouteSetByApi);
      thisClass.setClosureHandlers();
    }

    if (waitForEnd === true) this.associatedInteraction.keepOpenUntilEndApi = true;
  }, thisClass.featureName, thisClass.ee);
  registerHandler(INTERACTION_API + 'end', function (timeNow) {
    this.associatedInteraction.done(timeNow);
  }, thisClass.featureName, thisClass.ee);
  registerHandler(INTERACTION_API + 'save', function () {
    this.associatedInteraction.forceSave = true;
  }, thisClass.featureName, thisClass.ee);
  registerHandler(INTERACTION_API + 'ignore', function () {
    this.associatedInteraction.forceIgnore = true;
  }, thisClass.featureName, thisClass.ee);
  registerHandler(INTERACTION_API + 'getContext', function (time, callback) {
    var _this6 = this;

    if (typeof callback !== 'function') return;
    setTimeout(function () {
      return callback(_this6.associatedInteraction.customDataByApi);
    }, 0);
  }, thisClass.featureName, thisClass.ee);
  registerHandler(INTERACTION_API + 'onEnd', function (time, callback) {
    if (typeof callback !== 'function') return;
    this.associatedInteraction.onDone.push(callback);
  }, thisClass.featureName, thisClass.ee);
  registerHandler(INTERACTION_API + 'actionText', function (time, newActionText) {
    if (newActionText) this.associatedInteraction.customAttributes.actionText = newActionText;
  }, thisClass.featureName, thisClass.ee);
  registerHandler(INTERACTION_API + 'setName', function (time, name, trigger) {
    if (name) this.associatedInteraction.customName = name;
    if (trigger) this.associatedInteraction.trigger = trigger;
  }, thisClass.featureName, thisClass.ee);
  registerHandler(INTERACTION_API + 'setAttribute', function (time, key, value) {
    this.associatedInteraction.customAttributes[key] = value;
  }, thisClass.featureName, thisClass.ee);
  registerHandler(INTERACTION_API + 'routeName', function (time, newRouteName) {
    // notice that this fn tampers with the ixn IP, not with the linked ixn
    thisClass.latestRouteSetByApi = newRouteName;
    if (thisClass.interactionInProgress) thisClass.interactionInProgress.newRoute = newRouteName;
  }, thisClass.featureName, thisClass.ee);
}

_defineProperty(Aggregate, "featureName", FEATURE_NAME);

function getActionText(elem) {
  var tagName = elem.tagName.toLowerCase();
  var elementsOfInterest = ['a', 'button', 'input'];

  if (elementsOfInterest.includes(tagName)) {
    return elem.title || elem.value || elem.innerText;
  }
}